import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../api";
import AgentChat from "../components/agent/AgentChat";
import "../components/agent/AgentChat.css";
import SEO from "../components/SEO";
import { productPriceLabel, productSaleLabel } from "../utils/comparisonProducts";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [query, setQuery] = useState(q);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setQuery(q);
    if (!q.trim()) { setProducts([]); setError(""); setLoading(false); return undefined; }
    const controller = new AbortController();
    setLoading(true); setError("");
    api.get("/api/store/products", { params: { q: q.trim(), fields: "list", include_rental: true, representative: true, limit: 30 }, signal: controller.signal })
      .then(({ data }) => setProducts(data.products || []))
      .catch(err => { if (err.code !== "ERR_CANCELED") setError("검색 결과를 불러오지 못했습니다."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [q, retry]);
  return <main className="dept-ai-search-page bg-white min-h-screen">
    <SEO title="AI 제품 추천·검색" path="/search" description="사무실 환경에 맞는 복합기와 토너를 찾고 구매 가격과 월 렌탈료를 확인하세요." />
    <div className="max-w-[1100px] mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold">AI 제품 추천</h1><p className="text-gray-600 mt-3 mb-8">사무실 인원, 출력량, 예산을 알려주시면 제품 선택을 도와드립니다.</p>
      <div className="grid lg:grid-cols-2 gap-8">
        <section aria-label="AI 상담"><div className="dept-ai-chat-shell"><AgentChat siteName="일광오피스 AI 도우미" endpoint="/api/store/assistant/stream" getHeaders={() => { const token = localStorage.getItem("token"); return token ? { Authorization: `Bearer ${token}` } : {}; }} placeholder="예: 10명 사무실에서 사용할 컬러 복합기 추천" /></div><p className="mt-3 text-sm text-gray-600 leading-6">AI 답변은 참고용입니다. 가격·재고와 계약 조건은 상품 상세 및 상담에서 확인해 주세요. 개인정보가 포함된 내용은 입력하지 마세요. <Link to="/privacy#legal-4" className="underline">AI 정보 처리 안내</Link></p></section>
        <section aria-label="제품 검색"><h2 className="text-xl font-bold mb-4">모델명으로 찾기</h2>
          <form className="flex gap-2 mb-5" onSubmit={e => { e.preventDefault(); setParams(query.trim() ? { q: query.trim() } : {}); }}>
            <input aria-label="제품 모델명 검색" placeholder="모델명·토너명 입력" value={query} onChange={e => setQuery(e.target.value)} className="border p-3 min-w-0 flex-1" />
            <button className="bg-blue-800 text-white px-5" disabled={loading}>검색</button>
          </form>
          <div aria-live="polite">{loading ? <p>검색 중…</p> : error ? <p role="alert">{error} <button className="underline" onClick={() => setRetry(n => n + 1)}>다시 시도</button></p> : products.length ? <div className="space-y-3">{products.map(p => <Link key={p.id} to={`/p/${p.slug}`} className="flex gap-4 p-4 border hover:bg-blue-50"><img src={p.image_url} alt="" className="w-16 h-20 object-contain" /><div><p className="text-sm text-gray-600">{productSaleLabel(p)}{p.stock_status === "soldout" ? " · 품절" : ""}</p><h3 className="font-semibold my-1">{p.name}</h3><p>{productPriceLabel(p)}</p></div></Link>)}</div> : <p className="text-gray-600">{q ? "검색 결과가 없습니다. 다른 모델명으로 검색해 주세요." : "제품 이름을 입력하면 구매·렌탈 상품을 함께 확인할 수 있습니다."}</p>}</div>
        </section>
      </div>
    </div>
  </main>;
}
